<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="bp('configSaveHeader')"
    :z-index="16000011"
    :close-dialog-tooltip="bp('closeDialogToolTip')"
    qaid="project-one-save-config-dialog-container"
    @close="closeModal"
  >
    <p class="mb-4" qaid="project-one-save-dialog-description" v-html="bp('configSaveDescription')" />

    <form-group
      v-model="configurationName"
      v-validate="'required'"
      type="text"
      :name="bp('buildNameLabel').toLowerCase()"
      :maxlength="200"
      :label="bp('buildNameLabel')"
      :required="true"
      qaid="build-name-input"
      :show-error-messages="true"
      :error="errors.first(bp('buildNameLabel').toLowerCase())"
    />

    <div class="buttons buttons--right">
      <trek-button qaid="project-one-save-dialog-save" primary @click="saveBuild">
        <span v-html="bp('save')" />
      </trek-button>

      <trek-button qaid="project-one-save-dialog-cancel" secondary @click="closeModal">
        <span v-html="bp('cancel')" />
      </trek-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import ElDialog from '@/components/Dialog';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton.vue';

export default {
  name: 'ProjectOneSaveModal',

  components: {ElDialog, FormGroup, TrekButton},

  data() {
    return {
      configurationName: '',
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.isSaveModalVisible;
      },
      set(value) {
        this.setIsSaveModalVisible(value);
      },
    },

    ...mapState('projectOne', ['isSaveModalVisible', 'bikeData', 'onSaveCallbackFunction', 'onSaveActionName']),
  },

  methods: {
    saveBuild() {
      this.setBikeDataConfigurationDescription(this.configurationName);
      this.saveConfig(true)
        .then(() => {
          if (null != this.onSaveCallbackFunction) {
            this.onSaveCallbackFunction();
          }

          if (null != this.onSaveActionName) {
            this.$store.dispatch(`projectOne/${this.onSaveActionName}`);
          }
        })
        .catch((error) => {
          console.error(error);
          this.$notify({
            type: 'warning',
            message: this.bp('unableToProcess'),
          });
        })
        .finally(() => {
          this.closeModal();
        });
    },

    closeModal() {
      this.setIsSaveModalVisible(false);
      this.setOnSaveCallbackFunction(null);
      this.setOnSaveActionName(null);
    },

    ...mapActions('projectOne', ['saveConfig']),
    ...mapMutations('projectOne', [
      'setIsSaveModalVisible',
      'setBikeDataConfigurationDescription',
      'setOnSaveCallbackFunction',
      'setOnSaveActionName',
    ]),
  },
};
</script>
